const { toBool, toInt, toString } = require('@/functions/transform');

/**
 * @constructor
 */
const FloatAdjustmentReason = function () {
    this.ID = null;

    /**
     * @type {string}
     */
    this.reason = '';

    this.withdrawal = false;

    /**
     * Is entering a narrative required?
     *
     * @type {boolean}
     */
    this.narrative = false;

    this.requiredOnSessionClose = false;
};

FloatAdjustmentReason.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'floatAdjustmentReasonID'],
                transform: toInt,
            },
            narrative: toBool,
            reason: toString,
            withdrawal: toBool,
            requiredOnSessionClose: toBool,
        };
    },
};

module.exports = FloatAdjustmentReason;
